import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import { HeroSection } from './components/HeroSection'
import { DemoSection } from './components/DemoSection'
import { EditorialBlocks } from './components/EditorialBlocks'
import { UseCasesSection } from './components/UseCasesSection'
import { IntegrationsSection } from './components/IntegrationsSection'
import { PricingSection } from './components/PricingSection'
import { FinalCTA } from './components/FinalCTA'

export function LandingPage() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1)
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location.hash])

  return (
    <Box>
      <HeroSection />
      <DemoSection />
      <EditorialBlocks />
      <UseCasesSection />
      <IntegrationsSection />
      <PricingSection />
      <FinalCTA />
    </Box>
  )
}
